import Ayush from '../../assets/teams-images/Ayush.jpeg';
import Mohit from '../../assets/teams-images/Mohit_Upadhay.jpg';
import Aishwarya from '../../assets/teams-images/Aishwarya_tripathi.jpg';
import AviJain from '../../assets/teams-images/Avi Jain 23BAI11357.jpg';
import DebadritaDey from '../../assets/teams-images/DEBADRITA DEY 22BCE11219.jpg';
import AbhishekKumar from '../../assets/teams-images/Abhishek Kumar 23bhi10052.jpg';
import SnehaKumawat from '../../assets/teams-images/SNEHA KUMAWAT 22BCE10148.jpg';
import HimanshuDey from '../../assets/teams-images/HIMANSHU DEY 22BCY10220.jpg';
import VishalOjha from '../../assets/teams-images/Vishal Kumar Ojha 23bhi10067.jpg';
import HarshSaxena from '../../assets/teams-images/HARSH SAXENA 22BSA10139.jpg';
import MayankRathore from '../../assets/teams-images/Mayank Rathore 23bai10291.jpg';
import ShlokShukla from '../../assets/teams-images/Shlok Shukla 23bcg10094.jpg';
import MishitaVerma from '../../assets/teams-images/Mishita Verma 23bai10899.jpg';
import AvanishPratap from '../../assets/teams-images/Avanish Pratap Singh 23mim10017.jpg';
import YathanshJavkhedkar from '../../assets/teams-images/Yathansh Javkhedkar 23mim10099.jpg';
import SwapnilPrabhat from '../../assets/teams-images/Swapnil Prabhat 23bai10201.jpg';
import BhumikaSharma from '../../assets/teams-images/Bhumika Sharma 23bcy10041.jpg';
import AmreshwarSingh from '../../assets/teams-images/Amreshwar Singh 23bai10265.jpg';
import DhruvRai from '../../assets/teams-images/DHRUV RAI 22BCG10100.jpg';
import BhaskarRai from '../../assets/teams-images/BhaskarRai_CoporateTeam - BHASKAR RAI 22BCE11245.jpg';
import SagarSingh from '../../assets/teams-images/Sagar Singh 23bai10299.jpg';
import fc from '../../assets/teams-images/Mr_Margatrajan.jpg'
import fc2 from '../../assets/teams-images/Bhakti Parashar.png'
import Mehul from '../../assets/teams-images/Mehul.jpeg'
import ikshu from '../../assets/teams-images/ikshu.png'
export const boardMembers = [
  {
    name: "Ayush",
    role: "President",
    image: Ayush,
    social: {
      instagram: "https://instagram.com/username",
      linkedin: "https://linkedin.com/in/username",
      twitter: "https://twitter.com/username"
    }
  },
  {
    name: "Mohit Upadhyay",
    role: "General Secretary",
    image: Mohit,
    social: {
      instagram: "https://instagram.com/username",
      linkedin: "https://linkedin.com/in/username",
      twitter: "https://twitter.com/username"
    }
  },
  {
    name: "Aishwarya Tripathi",
    role: "Vice President",
    image: Aishwarya,
    social: {
      instagram: "https://instagram.com/username",
      linkedin: "https://linkedin.com/in/username",
      twitter: "https://twitter.com/username"
    }
  },
  {
    name: "Dr. M. Margatharajan",
    role: "Faculty Coordinator",
    image: fc,
    social: {
      instagram: "https://instagram.com/username",
      linkedin: "https://linkedin.com/in/username",
      twitter: "https://twitter.com/username"
    }
  },
  {
    name: "Dr. Bhakti Parashar",
    role: "Faculty Coordinator",
    image: fc2,
    social: {
      instagram: "https://instagram.com/username",
      linkedin: "https://linkedin.com/in/username",
      twitter: "https://twitter.com/username"
    }
  }
];

export const teamData = [
  {
    name: "Finance",
    orbit: 4,
    startAngle: 0,
    description: "Manages financial planning, budgeting, and sponsorship activities for the organization.",
    members: [
      {
        name: "Avi Jain",
        role: "Lead",
        image: AviJain,
        social: {
          instagram: "https://instagram.com/username",
          linkedin: "https://linkedin.com/in/username",
          twitter: "https://twitter.com/username"
        }
      },
      {
        name: "Debadrita Dey",
        role: "Lead",
        image: DebadritaDey,
        social: {
          instagram: "https://instagram.com/username",
          linkedin: "https://linkedin.com/in/username",
          twitter: "https://twitter.com/username"
        }
      }
    ]
  },
  {
    name: "Operation",
    orbit: 4,
    startAngle: 45,
    description: "Oversees day-to-day operations and ensures smooth execution of all activities.",
    members: [
      {
        name: "Abhishek Kumar",
        role: "Lead",
        image: AbhishekKumar,
        social: {
          instagram: "https://instagram.com/username",
          linkedin: "https://linkedin.com/in/username",
          twitter: "https://twitter.com/username"
        }
      },
      {
        name: "Sneha Kumawat",
        role: "Co-lead",
        image: SnehaKumawat,
        social: {
          instagram: "https://instagram.com/username",
          linkedin: "https://linkedin.com/in/username",
          twitter: "https://twitter.com/username"
        }
      }
    ]
  },
  {
    name: "Tech",
    orbit: 4,
    startAngle: 90,
    description: "Handles all technical aspects including website development and digital infrastructure.",
    members: [
      {
        name: "Himanshu Dey",
        role: "Lead",
        image: HimanshuDey,
        social: {
          instagram: "https://instagram.com/username",
          linkedin: "https://linkedin.com/in/username",
          twitter: "https://twitter.com/username"
        }
      },
      {
        name: "Vishal Kumar Ojha",
        role: "Co-lead",
        image: VishalOjha,
        social: {
          instagram: "https://instagram.com/username",
          linkedin: "https://linkedin.com/in/username",
          twitter: "https://twitter.com/username"
        }
      },
      {
        name: "Mehul Kumar Patel",
        role: "Member",
        image: Mehul ,
        social: {
          instagram: "https://instagram.com/username",
          linkedin: "https://linkedin.com/in/username",
          twitter: "https://twitter.com/username"
        }
      },
      {
        name: "Ikshu Patni",
        role: "Co-lead",
        image: ikshu ,
        social: {
          instagram: "https://instagram.com/username",
          linkedin: "https://linkedin.com/in/username",
          twitter: "https://twitter.com/username"
        }
      }
    ]
  },
  {
    name: "Design",
    orbit: 4,
    startAngle: 135,
    description: "Creates visual content and maintains brand consistency across all platforms.",
    members: [
      {
        name: "Harsh Saxena",
        role: "Lead",
        image: HarshSaxena,
        social: {
          instagram: "https://instagram.com/username",
          linkedin: "https://linkedin.com/in/username",
          twitter: "https://twitter.com/username"
        }
      },
      {
        name: "Mayank Rathore",
        role: "Co-lead",
        image: MayankRathore,
        social: {
          instagram: "https://instagram.com/username",
          linkedin: "https://linkedin.com/in/username",
          twitter: "https://twitter.com/username"
        }
      }
    ]
  },
  {
    name: "Socialmedia",
    orbit: 4,
    startAngle: 180,
    description: "Manages social media presence and engagement across all platforms.",
    members: [
      {
        name: "Shlok Shukla",
        role: "Lead",
        image: ShlokShukla,
        social: {
          instagram: "https://instagram.com/username",
          linkedin: "https://linkedin.com/in/username",
          twitter: "https://twitter.com/username"
        }
      },
      {
        name: "Mishita Verma",
        role: "Co-lead",
        image: MishitaVerma,
        social: {
          instagram: "https://instagram.com/username",
          linkedin: "https://linkedin.com/in/username",
          twitter: "https://twitter.com/username"
        }
      }
    ]
  },
  {
    name: "Events",
    orbit: 4,
    startAngle: 225,
    description: "Plans and executes all events and programs throughout the year.",
    members: [
      {
        name: "Avanish Pratap Singh",
        role: "Lead",
        image: AvanishPratap,
        social: {
          instagram: "https://instagram.com/username",
          linkedin: "https://linkedin.com/in/username",
          twitter: "https://twitter.com/username"
        }
      },
      {
        name: "Yathansh Javkhedkar",
        role: "Co-lead",
        image: YathanshJavkhedkar,
        social: {
          instagram: "https://instagram.com/username",
          linkedin: "https://linkedin.com/in/username",
          twitter: "https://twitter.com/username"
        }
      },
      {
        name: "Swapnil Prabhat",
        role: "Co-lead",
        image: SwapnilPrabhat,
        social: {
          instagram: "https://instagram.com/username",
          linkedin: "https://linkedin.com/in/username",
          twitter: "https://twitter.com/username"
        }
      }
    ]
  },
  {
    name: "Content",
    orbit: 4,
    startAngle: 270,
    description: "Creates and manages all content for various communication channels.",
    members: [
      {
        name: "Bhumika Sharma",
        role: "Co-lead",
        image: BhumikaSharma,
        social: {
          instagram: "https://instagram.com/username",
          linkedin: "https://linkedin.com/in/username",
          twitter: "https://twitter.com/username"
        }
      },
      {
        name: "Amreshwar Singh",
        role: "Co-lead",
        image: AmreshwarSingh,
        social: {
          instagram: "https://instagram.com/username",
          linkedin: "https://linkedin.com/in/username",
          twitter: "https://twitter.com/username"
        }
      }
    ]
  },
  {
    name: "Corporate",
    orbit: 4,
    startAngle: 315,
    description: "Manages corporate relationships and partnerships for the organization.",
    members: [
      {
        name: "Dhruv Rai",
        role: "Lead",
        image: DhruvRai,
        social: {
          instagram: "https://instagram.com/username",
          linkedin: "https://linkedin.com/in/username",
          twitter: "https://twitter.com/username"
        }
      },
      {
        name: "Bhaskar Rai",
        role: "Co-lead",
        image: BhaskarRai,
        social: {
          instagram: "https://instagram.com/username",
          linkedin: "https://linkedin.com/in/username",
          twitter: "https://twitter.com/username"
        }
      },
      {
        name: "Sagar Singh",
        role: "Co-lead",
        image: SagarSingh,
        social: {
          instagram: "https://instagram.com/username",
          linkedin: "https://linkedin.com/in/username",
          twitter: "https://twitter.com/username"
        }
      }
    ]
  }
];